import { ControlLink, Stack } from '@moda/om';
import classNames from 'classnames';
import React from 'react';
import { useMobileNavV2Query } from '../useMobileNavV2Query';

import './MobileNavV2Header.scss';

interface Props {
  onChange: (index: number) => void;
  selectedTabIndex: number;
}

export const MobileNavV2Header: React.FC<Props> = ({ onChange, selectedTabIndex }) => {
  const { navigator } = useMobileNavV2Query();

  const items = navigator?.tabs;

  if (!items) return null;

  return (
    <Stack
      className="MobileNavV2Header"
      direction="horizontal"
      justifyContent="space-between"
      space={0}
    >
      {items.map(({ name }, index) => (
        <div
          className={classNames('MobileNavV2Header__tab', {
            'MobileNavV2Header__tab--selected': selectedTabIndex == index,
            'MobileNavV2Header__tab--two-items': items.length === 2,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            'MobileNavV2Header__tab--three-items': items.length === 3,
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            'MobileNavV2Header__tab--four-items': items.length === 4
          })}
          onClick={() => onChange(index)}
          onKeyDown={() => onChange(index)}
          key={`${name} -- ${index}`}
          role="button"
          tabIndex={selectedTabIndex === index ? -1 : 0}
        >
          <ControlLink underlined={selectedTabIndex === index}>{name.toUpperCase()}</ControlLink>
        </div>
      ))}
    </Stack>
  );
};
